module.exports = __webpack_public_path__ + "img/ax.8716c282.svg";